import { render, staticRenderFns } from "./ListWrapperElement.vue?vue&type=template&id=16bf7874&"
import script from "./ListWrapperElement.vue?vue&type=script&lang=js&"
export * from "./ListWrapperElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports